import axios from "axios";

// Messaging Inbox — thin wrapper around the uwill-api conversations/messages/drafts
// endpoints.

function fetchInbox({ cursor, product, caseState, q, limit } = {}) {
  return axios.get("/conversations", {
    params: { cursor, product, caseState, q, limit }
  });
}

function fetchThread(conversationToken, { before, limit } = {}) {
  return axios.get(`/conversations/${conversationToken}/messages`, {
    params: { before, limit }
  });
}

function fetchEligibleTargets() {
  return axios.get("/conversations/eligible_targets");
}

// Cheap poll target - no audit-log write, no read-marker advance, unlike
// fetchThread. `since` is the highest message id already known locally.
function peekThread(conversationToken, since) {
  return axios.get(`/conversations/${conversationToken}/peek`, {
    params: { since }
  });
}

function fetchUnreadCount() {
  return axios.get("/conversations/unread_count");
}

// Cheap poll target for the whole list - a single MAX(last_message_id)
// aggregate, no preload, no per-conversation detail. `since` is the highest
// last_message_id already reflected in the currently loaded list.
function peekInbox(since) {
  return axios.get("/conversations/peek", { params: { since } });
}

function sendMessage({
  recipientId,
  conversationToken,
  product,
  basicNeedsCaseId,
  body,
  attachmentIds,
  idempotencyKey
} = {}) {
  return axios.post(
    "/conversations/messages",
    {
      recipientId,
      conversationToken,
      product,
      basicNeedsCaseId,
      body,
      attachmentIds
    },
    {
      headers: {
        "Idempotency-Key": idempotencyKey,
        "Content-Type": "application/json"
      }
    }
  );
}

function saveDraft({
  composeToken,
  conversationToken,
  recipientId,
  product,
  basicNeedsCaseId,
  body,
  attachmentIds
} = {}) {
  return axios.post(
    "/drafts",
    {
      composeToken,
      conversationToken,
      recipientId,
      product,
      basicNeedsCaseId,
      body,
      attachmentIds
    },
    { headers: { "Content-Type": "application/json" } }
  );
}

// onUploadProgress lets the caller tell "bytes still transferring" apart
// from "bytes sent, waiting on the response" (the latter covers CarrierWave
// validation/HEIC conversion/S3 store, all in this one request).
function createAttachment({ composeToken, file, onUploadProgress }) {
  const formData = new FormData();
  formData.append("composeToken", composeToken);
  formData.append("file", file);
  return axios.post("/conversation_message_attachments", formData, {
    headers: { "Content-Type": undefined },
    onUploadProgress
  });
}

export default {
  fetchInbox,
  fetchThread,
  fetchEligibleTargets,
  fetchUnreadCount,
  peekThread,
  peekInbox,
  sendMessage,
  saveDraft,
  createAttachment
};
